<template>
  <div class="site-shell">
    <v-navigation-drawer v-model="drawer" app width="285" class="drawer">
      <div class="drawer-brand" @click="$router.push('/principal')">
        <v-img :src="require('@/assets/logo.png')" contain max-width="138" />
        <p>Personalizamos tus ideas</p>
      </div>

      <v-divider />
      <v-list dense nav class="px-3 py-4">
        <v-list-item link to="/principal" color="primary" class="menu-item">
          <v-list-item-icon><v-icon>mdi-home-outline</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Inicio</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-list-item link @click="showAllProducts" color="primary" class="menu-item">
          <v-list-item-icon><v-icon>mdi-view-grid-outline</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Todos los productos</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-subheader class="category-heading">CATEGORÍAS</v-subheader>
        <v-skeleton-loader v-if="loadingCategories" type="list-item-two-line@4" />

        <v-list-group
          v-for="category in listCategory"
          :key="category.dataCategory.id || category.id"
          no-action
          color="primary"
        >
          <template v-slot:activator>
            <v-list-item-icon class="mr-3">
              <v-icon>{{ category.dataCategory.icon || 'mdi-shape-outline' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">{{ category.dataCategory.name }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="subCategory in category.resultsDataSubCategory"
            :key="subCategory.id"
            link
            class="subcategory-item"
            @click="selectCategory(subCategory)"
          >
            <v-list-item-icon class="mr-2"><v-icon small color="primary">mdi-chevron-right</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>{{ subCategory.name }}</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-divider class="my-4" />
        <v-list-item link @click="goToSupplies" class="menu-item supplies-link">
          <v-list-item-icon><v-icon>mdi-package-variant-closed</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Insumos de sublimación</v-list-item-title>
            <v-list-item-subtitle>Próximamente</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="white" elevate-on-scroll class="topbar">
      <v-app-bar-nav-icon color="primary" @click.stop="drawer = !drawer" />
      <div class="topbar-brand d-none d-sm-flex" @click="$router.push('/principal')">
        <span>Aguila Print</span>
        <small>Regalos y productos personalizados</small>
      </div>
      <v-spacer />
      <v-btn text color="primary" class="d-none d-md-flex mr-2" @click="openWhatsApp">
        <v-icon left>mdi-whatsapp</v-icon> Escríbenos
      </v-btn>
      <Account />
      <Cart />
    </v-app-bar>

    <main class="main-content">
      <router-view />
    </main>

    <v-btn fixed bottom right fab color="#25D366" dark class="whatsapp-fab" @click="openWhatsApp">
      <v-icon size="30">mdi-whatsapp</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Cart from "./Cart.vue";
import Account from "./Account.vue";

export default {
  name: "MainView",
  components: { Cart, Account },
  data: () => ({ drawer: null, listCategory: [], loadingCategories: false }),
  methods: {
    selectCategory(subCategory) {
      this.$store.dispatch("updateCategory", subCategory);
      if (this.$route.path !== "/product") this.$router.push("/product");
      if (this.$vuetify.breakpoint.smAndDown) this.drawer = false;
    },
    showAllProducts() {
      this.$store.dispatch("updateCategory", null);
      if (this.$route.path !== "/product") this.$router.push("/product");
    },
    loadCategory() {
      this.loadingCategories = true;
      this.$axios.get("/api/category-menu")
        .then(res => { this.listCategory = (res.data && res.data.data) || []; })
        .catch(error => console.error("No se pudieron cargar las categorías", error))
        .finally(() => { this.loadingCategories = false; });
    },
    openWhatsApp() {
      window.open("https://wa.me/584146058924?text=Hola%20Aguila%20Print,%20quiero%20personalizar%20un%20producto", "_blank");
    },
    goToSupplies() {
      this.$router.push({ path: "/principal", query: { section: "insumos" } });
      this.$nextTick(() => {
        const section = document.getElementById("insumos");
        if (section) section.scrollIntoView({ behavior: "smooth" });
      });
    },
  },
  mounted() { this.loadCategory(); },
};
</script>

<style scoped>
.site-shell { min-height: 100%; background: #f8f7fb; }
.drawer { border-right: 1px solid #eee !important; }
.drawer-brand { padding: 22px 24px 18px; cursor: pointer; }
.drawer-brand p { margin: 8px 0 0; color: #777; font-size: 12px; }
.category-heading { margin-top: 16px; color: #6b2da8 !important; font-weight: 800; letter-spacing: .08em; }
.menu-item { border-radius: 10px; margin-bottom: 4px; }
.subcategory-item { padding-left: 38px !important; }
.supplies-link { background: #f5edff; border-radius: 12px; }
.topbar { border-bottom: 1px solid #eee !important; }
.topbar-brand { flex-direction: column; cursor: pointer; line-height: 1.1; }
.topbar-brand span { color: #5c168d; font-size: 18px; font-weight: 800; }
.topbar-brand small { margin-top: 4px; color: #7f7f7f; }
.main-content { min-height: calc(100vh - 64px); }
.whatsapp-fab { z-index: 20; box-shadow: 0 10px 28px rgba(37, 211, 102, .35) !important; }
</style>
